import * as React from 'react';
import videojs from 'video.js';
import 'videojs-contrib-ads';
import 'video.js/dist/video-js.css';
// import '@arte/videojs-vast';

export const VideoJS = (props) => {
  const videoRef = React.useRef(null);
  const playerRef = React.useRef(null);
  const canvasRef = React.useRef(null);
  const {options, onReady, isAd} = props;

  const containerRef = React.useRef(null);

  React.useEffect(() => {
    if (!canvasRef.current) return;
    if (!containerRef.current) return;
    canvasRef.current.width  = containerRef.current.clientWidth;
    canvasRef.current.height = containerRef.current.clientHeight;
  }, [canvasRef, containerRef]);

  const vastVjsOptions = {
    vastUrl: 'https://vast.yomeno.xyz/vast?spot_id=1444422',
  };

  React.useEffect(() => {
    if (!playerRef.current) {
      const player = playerRef.current = videojs(videoRef.current, options, () => {
        onReady && onReady(player);
      });

      // if (isAd) {
      //   player.vast(vastVjsOptions);
      // } 

      const computeFrame = () => {
        if (!canvasRef.current) return;
        if (!videoRef.current) return;

        const ctx = canvasRef.current.getContext("2d");
        const vidh = videoRef.current.clientHeight;
        const canvW = canvasRef.current.width;
        const canvH = canvasRef.current.height;

        let dy = canvH - vidh;

        ctx.drawImage(videoRef.current, 0, dy/2, canvW, vidh);
        let iterTop = Math.ceil(dy/40);

        let topData = ctx.getImageData(0, dy/2, canvW, 20);
        for (let i = 0; i < iterTop; i++) {
          ctx.putImageData(topData, 0, i * 20);
        }

        let bottomData = ctx.getImageData(0, dy/2 + vidh - 20, canvW, 20);
        for (let i = 0; i < iterTop; i++) {
          ctx.putImageData(bottomData, 0, dy/2 + vidh + (i * 20));
        }
      }

      let start;
      const fps = 24;

      const timerCallback = (dtTs) => {

        if (player.paused()) {
          start = null;
          return;
        }

        if (!start) {
          start = dtTs;
        }

        if ((dtTs - start) >= 1000/fps) {
          start = dtTs;
          computeFrame();
        }        
        
        requestAnimationFrame(timerCallback);
      };

      player.on(
        "play",
        () => {
          requestAnimationFrame(timerCallback);
        },
      );

    }
  }, [options, videoRef]);

  return (
    <div ref={containerRef} className='relative z-0 w-full h-full flex box-border justify-center items-center sm-line video-overlay' data-vjs-player>
      <canvas ref={canvasRef} className='blur-2xl absolute w-full h-full z-[-1] opacity-90 scale-125' /> 
      <video style={{ width: '100%', maxHeight: '100%'}} autoPlay={false} playsInline disablePictureInPicture ref={videoRef} />
    </div>
  );
}

export default React.memo(VideoJS);